import config from '@/config';
import { IGenericObject } from '@/shared';
import { baseRequest } from './base-request';

export const oauthRequest = {
  get: async (path: string, id?: string | number) => {
    const result = await baseRequest.get(`${config?.oauthService}${path}`);
    return result;
  },
  post: (path: string, data: IGenericObject) => baseRequest.post(
    `${config?.oauthService}${path}`,
    data,
  ),
  put: (path: string, data: IGenericObject) => baseRequest.put(
    `${config?.oauthService}${path}`,
    data,
  ),
  patch: (path: string, data: IGenericObject) => baseRequest.patch(
    `${config?.oauthService}${path}`,
    data,
  ),
  delete: (path: string, ids: number[] | string[]) => baseRequest.delete(
    `${config?.oauthService}${path}/${ids.join(',')}`,
  ),
};
